import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getDecorationSpecsState = (state: RootState) => state.pages.editor.decorationSpecs;

const getDecorationSpecs = createSelector([getDecorationSpecsState], (data) => data);

export default getDecorationSpecs;
